import * as React from 'react';

const Filters16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.955 3.152c.06.11.11.22.15.34l.01.01H15v1.5H8.105c-.18.52-.54.95-1.02 1.22-.34.18-.71.28-1.09.28-.2 0-.41-.03-.62-.09a2.192 2.192 0 0 1-1.5-1.41H1.001v-1.5h2.874c.18-.52.54-.95 1.02-1.22.52-.3 1.13-.36 1.71-.2.58.16 1.06.54 1.35 1.07Zm-2.72 1.09c0 .41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75Zm2.478 6.407c-.06.11-.11.22-.15.34l-.01.01h-6.55v1.5h6.56c.18.52.54.95 1.02 1.22.34.18.71.28 1.09.28.2 0 .41-.03.62-.09a2.192 2.192 0 0 0 1.5-1.41h3.203v-1.5h-3.203c-.18-.52-.54-.95-1.02-1.22-.52-.3-1.13-.36-1.71-.2-.58.16-1.06.54-1.35 1.07Zm2.72 1.09c0 .41-.34.75-.75.75s-.75-.34-.75-.75.34-.75.75-.75.75.34.75.75Z"
  }
));
Filters16.Size = 16;
Filters16.Title = "Filters";

export { Filters16 as default };
